
import { useParams } from '../../../../contexts/RouterContext';
import { useReleaseGroup } from '../../../../hooks/api/releaseGroups/useReleaseGroup';
import { useSelectedReleaseId } from '../../../../redux/project_grouping/hooks';
import { toFiniteNumber } from '../../../../utils';

import usePortalUrl from './usePortalUrl';

/** hook to return the url of the selected release group release's report in the portal. */
function useReportUrl() {
  const { url } = usePortalUrl();
  const params = useParams<{ projectGroupId?: string }>();
  const projectGroupId = toFiniteNumber(params.projectGroupId);
  const releaseId = useSelectedReleaseId(projectGroupId);
  const { data: currentGroup } = useReleaseGroup(projectGroupId ?? 0, !!projectGroupId);

  return {
    url: url && projectGroupId && releaseId && `${url}/release/${projectGroupId}/${releaseId}`,
    isPublic: projectGroupId ? currentGroup?.publicOnPortal : undefined,
  };
}

export default useReportUrl;
